const TildePresente = ({ height, width }) => {
  return (
    <svg
      width={width ? width : "18"}
      height={height ? height : "17"}
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="9.39441"
        cy="8.58887"
        r="7.40234"
        stroke="#3D994A"
        strokeWidth="2"
      />
      <path
        d="M5.4668 8.68799L7.9474 11.3753L13.3221 5.79395"
        stroke="#3D994A"
        strokeWidth="2"
      />
    </svg>
  );
};

export default TildePresente;
